import React, { useState } from "react";
import PageHero from "../components/PageHero";
import AssetVisual from "../components/AssetVisual";

const STRATEGY = [
  ["Acquire", "Off-market and pre-launch deal flow surfaced before it hits any portal — priced for entry, not for retail."],
  ["Optimize", "Title clean-up, repositioning, and design-build value-add that lifts an asset's exit multiple."],
  ["Multiply", "Disciplined short-to-mid-term flips and rental yield plays, actively managed against a target ROI."],
];

const PERKS = [
  "Private, off-market deal flow",
  "Underwriting & ROI modelling on every deal",
  "Design-build value-add, costed upfront",
  "Priority bank-alliance leverage",
  "Title & risk vetting included",
  "Discreet, single-point relationship desk",
];

export default function InvestorsPage() {
  const [sent, setSent] = useState(false);

  return (
    <>
      <PageHero
        eyebrow="Wealth Desk · By invitation"
        title="Real estate, run as a"
        italic="portfolio."
        sub="A private funnel for investors who treat property as an asset class — built around entry pricing, active value-add, and a disciplined exit. Discreet by design."
        tone={["#0B0B0C", "#241d10"]}
      />

      {/* Strategy */}
      <section className="section">
        <div className="shell">
          <div className="reveal" style={{ maxWidth: 640, marginBottom: 50 }}>
            <span className="eyebrow">The mandate</span>
            <h2 className="h-xl" style={{ marginTop: 16 }}>Buy well. Improve sharply.<br />Exit on schedule.</h2>
          </div>
          <div className="grid" style={{ gridTemplateColumns: "repeat(3,1fr)" }}>
            {STRATEGY.map(([t, b], i) => (
              <div key={t} className="reveal" style={{ borderTop: "1px solid var(--alabaster-dim)", paddingTop: 24 }}>
                <span style={{ fontFamily: "var(--serif)", fontSize: "2.2rem", color: "var(--champagne)" }}>0{i + 1}</span>
                <h3 className="h-md" style={{ margin: "12px 0 10px" }}>{t}</h3>
                <p className="muted">{b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Numbers band */}
      <section className="section dark" style={{ paddingTop: "clamp(56px,8vw,104px)" }}>
        <div className="shell">
          <div className="grid" style={{ gridTemplateColumns: "1fr 1fr", gap: "clamp(32px,5vw,72px)", alignItems: "center" }}>
            <div className="reveal">
              <span className="eyebrow on-dark">The Aditi edge for investors</span>
              <h2 className="h-lg" style={{ marginTop: 16 }}>Where the margin<br />actually comes from.</h2>
              <p className="muted" style={{ marginTop: 18 }}>
                Returns in real estate are made at entry and at exit — not in the
                middle. Because we source off-market, vet title in-house, and build
                value with our own studio, we compress both ends of the trade.
              </p>
              <div className="grid" style={{ gridTemplateColumns: "1fr 1fr", gap: 16, marginTop: 30 }}>
                {PERKS.map((x) => (
                  <div key={x} style={{ borderLeft: "1px solid var(--champagne)", paddingLeft: 14, fontSize: "0.92rem" }} className="muted">{x}</div>
                ))}
              </div>
            </div>
            <div className="reveal" style={{ aspectRatio: "4/5", borderRadius: 8, overflow: "hidden" }}>
              <AssetVisual tone={["#16130e", "#3a2f17"]} accent="#D4AF37" label="Wealth & Arbitrage" />
            </div>
          </div>
        </div>
      </section>

      {/* VIP application funnel */}
      <section className="section">
        <div className="shell">
          <div className="reveal" style={{ maxWidth: 760, margin: "0 auto", background: "var(--obsidian)", color: "var(--paper-ink)", borderRadius: 10, padding: "clamp(32px,5vw,64px)", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", inset: 0, opacity: 0.3 }}><AssetVisual tone={["#0B0B0C", "#241d10"]} accent="#D4AF37" /></div>
            <div style={{ position: "relative" }}>
              <span className="eyebrow gold" style={{ justifyContent: "center", display: "flex" }}>Request access</span>
              <h2 className="h-lg center" style={{ margin: "16px 0 10px" }}>Apply to the Wealth Desk</h2>
              <p className="muted center" style={{ maxWidth: 480, margin: "0 auto 32px" }}>
                Access is selective and capped each quarter. Tell us your mandate and
                ticket size; we'll respond privately.
              </p>

              {sent ? (
                <div className="center" style={{ padding: "30px 0" }}>
                  <span className="badge live" style={{ background: "transparent" }}><span className="dot" /> Application received</span>
                  <p className="muted" style={{ marginTop: 16 }}>A desk principal will reach out personally. Thank you.</p>
                </div>
              ) : (
                <form onSubmit={(e) => { e.preventDefault(); setSent(true); }} style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                  <div className="field"><label>Full name</label><input required placeholder="Your name" /></div>
                  <div className="field"><label>Email</label><input required type="email" placeholder="you@email.com" /></div>
                  <div className="field"><label>Investment horizon</label>
                    <select required defaultValue=""><option value="" disabled>Select…</option><option>Short term (under 12 mo)</option><option>Mid term (1–3 yrs)</option><option>Opportunistic</option></select>
                  </div>
                  <div className="field"><label>Ticket size</label>
                    <select required defaultValue=""><option value="" disabled>Select…</option><option>₹1–5 Cr</option><option>₹5–25 Cr</option><option>₹25 Cr+</option></select>
                  </div>
                  <div className="field" style={{ gridColumn: "1 / -1" }}><label>Your mandate</label><textarea placeholder="What kind of deals are you looking for?" /></div>
                  <button type="submit" className="btn btn-gold" style={{ gridColumn: "1 / -1", justifyContent: "center" }}>Request private access <span className="arr">→</span></button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 820px) {
          .section .grid[style*="repeat(3"] { grid-template-columns: 1fr !important; }
          .section .grid[style*="1fr 1fr"] { grid-template-columns: 1fr !important; }
          form[style*="1fr 1fr"] { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </>
  );
}
